import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastData } from '@shared/add-ons/toast/toast.component';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoadingService } from './loading.service';
import { ToastService } from './toast.service';

export const errorInterceptorFn: HttpInterceptorFn = (request, next) => {
  const toastService = inject(ToastService);
  const loadingService = inject(LoadingService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      loadingService.hide();
      if (
        !(error.status === 401 && (error.message === '' || (error.url && error.url.includes('api/account'))))
      ) {
        toastService.open({ type: 'error', message: error.message } as ToastData, 5000);
      }
      return throwError(() => error);
    })
  );
};
